module.exports = __webpack_public_path__ + "static/media/Swift_logo.c32f0d4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Portfolio/Swift_logo.svg
// module id = 33
// module chunks = 0